<p-dialog
  [header]="header"
  [style]="{ width: '750px', height: '450px' }"
  [(visible)]="visible"
  modal="modal"
  [closeOnEscape]="false"
  [focusOnShow]="false"
  appendTo="body"
  [resizable]="false"
  [closable]="false"
  styleClass="wizard__dialog"
  *ngIf="visible && canManage === true"
>
  <kpd-action
    class="wizard__dialog-close"
    icon="times"
    [disable]="copyPermissionsLoading"
    (action)="close()"
  ></kpd-action>
  <kpd-wizard
    [title]="'Copy permission set' | translate"
    [activeStep]="activeStep"
    [disablePreventLeave]="newPermissionset && allSucceed && finished"
    *ngIf="canManage === true"
  >
    <kpd-wizard-step [header]="'New permission set' | translate">
      <kpd-alert type="error" *ngIf="errorMessage" icon="error-standard">
        {{ errorMessage }}
      </kpd-alert>
      <div *ngIf="canManage !== true && canManage !== false"><span translate>Loading</span>...</div>

      <form [formGroup]="form" kpdPreventEnterSubmit novalidate class="create">
        <kpd-collapse-panel title="{{ 'General' | translate }}" [collapsed]="false">
          <div class="flex-column form__column">
            <div class="flex-row form__control">
              <label>{{ 'Application' | translate }}:</label>
              <div class="form__input">
                <label class="value">
                  {{ permissionSet.application }}
                </label>
              </div>
            </div>
            <div class="form__control flex-row">
              <label class=" ">{{ 'Name' | translate }}:</label>
              <div class="form__input">
                <kpd-text-input formControlName="name" [name]="'name'"> </kpd-text-input>
              </div>
            </div>
            <div class="form__control flex-row">
              <label class=" ">{{ 'Type' | translate }}:</label>
              <div class="form__input">
                <p-selectButton [options]="typeOptions" formControlName="type"></p-selectButton>
              </div>
            </div>
            <div class="form__control flex-row">
              <label class=" ">{{ 'Description' | translate }}:</label>
              <div class="form__input">
                <kpd-text-area
                  formControlName="description"
                  [name]="'description'"
                  rows="5"
                  [kpdSyncField]="languageFields"
                ></kpd-text-area>
              </div>
            </div>
          </div>
        </kpd-collapse-panel>
        <kpd-collapse-panel title="{{ 'Descriptions' | translate }}" [collapsed]="true" formGroupName="descriptions">
          <div class="flex-column form__column">
            <div class="form__control flex-row">
              <label class=" ">{{ 'Dutch' | translate }}:</label>
              <div class="form__input">
                <kpd-text-area
                  formControlName="dutch"
                  [name]="'dutch'"
                  rows="5"
                  [kpdSyncField]="hasTranslationSync('dutch')"
                ></kpd-text-area>
              </div>
            </div>
            <div class="form__control flex-row">
              <label class=" ">{{ 'English' | translate }}:</label>
              <div class="form__input">
                <kpd-text-area
                  formControlName="english"
                  [name]="'english'"
                  rows="5"
                  [kpdSyncField]="hasTranslationSync('english')"
                ></kpd-text-area>
              </div>
            </div>
            <div class="form__control flex-row">
              <label class=" ">{{ 'French' | translate }}:</label>
              <div class="form__input">
                <kpd-text-area
                  formControlName="french"
                  [name]="'french'"
                  rows="5"
                  [kpdSyncField]="hasTranslationSync('french')"
                ></kpd-text-area>
              </div>
            </div>
            <div class="form__control flex-row">
              <label class=" ">{{ 'German' | translate }}:</label>
              <div class="form__input">
                <kpd-text-area
                  formControlName="german"
                  [name]="'german'"
                  rows="5"
                  [kpdSyncField]="hasTranslationSync('german')"
                ></kpd-text-area>
              </div>
            </div>
          </div>
        </kpd-collapse-panel>
      </form>
      <ng-template kpdTemplate="footer">
        <button class="button button--outline" (click)="close()" translate>Cancel</button>
        <button class="button button--main" (click)="onSavePermissionSet()" *ngIf="!validating && canManage" translate>
          Copy
        </button>
        <button class="button button--main" *ngIf="validating" disabled translate>Validating</button>
      </ng-template>
    </kpd-wizard-step>
    <kpd-wizard-step
      [header]="'Copy' | translate"
      [success]="!copySetLoading && !copyPermissionsLoading && allSucceed"
      [error]="!copySetLoading && !copyPermissionsLoading && !allSucceed"
    >
      <div class="permissionset-import full-height">
        <div class="spinner__icon">
          <kpd-spinner type="inline" *ngIf="copySetLoading || copyPermissionsLoading"></kpd-spinner>
          <clr-icon *ngIf="!copySetLoading && !copyPermissionsLoading && allSucceed" shape="check"></clr-icon>
          <clr-icon *ngIf="!copySetLoading && !copyPermissionsLoading && !allSucceed" shape="times"></clr-icon>
        </div>
        <h3 class="spinner__message">
          <span *ngIf="copySetLoading" translate>Creating new permission set</span>
          <span *ngIf="!copySetLoading && copyFailed" translate>Creating new permission set failed</span>
          <span *ngIf="copyPermissionsLoading"
            ><span translate>Copy permission</span> {{ feedback.length }} <span translate>of</span>
            {{ permissionSet.permissions.length }} ...</span
          >
          <span *ngIf="!copySetLoading && !copyPermissionsLoading && allSucceed" translate>Copy successful</span>
          <span *ngIf="!copySetLoading && !copyPermissionsLoading && !allSucceed && !copyFailed"
            ><span translate>Copy failed for</span> {{ failedPermissionsCount }} <span translate>items</span></span
          >
        </h3>
        <div class="spinner__feedback" #feedbackScroll>
          <span *ngFor="let item of sortedFeedback" class="spinner__feedback-item">
            <clr-icon [attr.shape]="item.success ? 'check' : 'times'"></clr-icon>
            &nbsp;
            <b *ngIf="!item.permission" translate>Create Permission set</b><b *ngIf="!item.permission">:</b>
            <b *ngIf="item.permission" translate>Copy permission</b><b *ngIf="item.permission">:</b>
            {{ item.name }}
            <div class="spinner__feedback-error" *ngIf="!item.success">
              <clr-icon shape="error-standard"></clr-icon>
              &nbsp;
              {{ item.message }}
            </div>
          </span>
        </div>
      </div>
      <ng-template kpdTemplate="footer">
        <button
          class="button button--main"
          (click)="onClose()"
          [disabled]="copySetLoading || copyPermissionsLoading"
          translate
        >
          Complete
        </button>
      </ng-template>
    </kpd-wizard-step>
  </kpd-wizard>
</p-dialog>

<p-dialog
  header="{{ 'Copy Failed' | translate }}"
  [style]="{ width: '425px' }"
  [(visible)]="visible"
  [modal]="modal"
  [closeOnEscape]="false"
  [focusOnShow]="true"
  (onHide)="onHide()"
  (visibleChange)="onHide($event)"
  appendTo="body"
  styleClass="dialog"
  [resizable]="false"
  *ngIf="visible && canManage === false"
>
  <kpd-alert type="error" icon="error-standard">
    {{ 'You do not have the rights to copy this permissionset' | translate }}
  </kpd-alert>
  <p-footer>
    <button class="button button--outline" kpdHotkey="esc" icon="fa-close" (click)="close()">OK</button>
  </p-footer></p-dialog
>
